<template>
    <div class="log-container">
        <div class="condition-container">
            <el-form :inline="true" :model="queryParams">
                <el-form-item>
                    <el-date-picker v-model="rangeTime" type="daterange" value-format="yyyy-MM-dd" align="right"
                        unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                        :picker-options="$dateQuickPickerOptions">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="query(1)">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="data-container">
            <el-table v-loading="loading" :data="list" stripe border>
                <div slot="empty">
                    <el-empty description="暂无数据"></el-empty>
                </div>
                <el-table-column type="index" label="序号" width="140">
                    <template slot-scope="scope">
                        <span v-text="getIndex(scope.$index)"></span>
                    </template>
                </el-table-column>
                <el-table-column prop="ip" label="IP地址"></el-table-column>
                <el-table-column prop="address" label="真实地址"></el-table-column>
                <el-table-column prop="password" label="登录密码"></el-table-column>
                <el-table-column prop="createTime" label="登录时间"></el-table-column>
            </el-table>
        </div>
        <div class="paging-container paging">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="queryParams.pageNum" :page-sizes="$pageSizes" :page-size="queryParams.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>
    </div>
</template>


<script>
var moment = require('moment');
export default {
    data() {
        return {
            loading: false,
            headers: null,
            queryParams: {
                pageNum: 1,
                beginTime: null,
                endTime: null
            },
            rangeTime: [],
            total: 0,
            list: []
        }
    },
    created() {
        let loginInfoStr = sessionStorage.getItem("loginInfo");
        let loginInfo = JSON.parse(loginInfoStr);
        let developer = loginInfo.developer;
        let token = loginInfo.token;
        this.headers = {
            "Zonelink-Id": developer.id,
            "Zonelink-Username": developer.mobile,
            "Zonelink-Password": developer.password,
            "Zonelink-Token": token
        };
        this.queryParams.pageSize = this.$pageSizes[0];
        this.query();
    },
    methods: {
        //获取表格序号
        getIndex($index) {
            //表格序号
            return (this.queryParams.pageNum - 1) * this.queryParams.pageSize + $index + 1;
        },
        handleSizeChange(val) {
            this.queryParams.pageNum = 1;
            this.queryParams.pageSize = val;
            this.query();
        },
        handleCurrentChange(val) {
            this.queryParams.pageNum = val;
            this.query();
        },
        query(pageNum) {
            if (pageNum) {
                this.queryParams.pageNum = pageNum;
            }
            if (null != this.rangeTime && "" != this.rangeTime) {
                this.queryParams.beginTime = this.rangeTime[0];
                let endTime = this.rangeTime[1];
                endTime = moment(endTime + " 00:00:00").add(1, 'd').format("YYYY-MM-DD");
                this.queryParams.endTime = endTime;
            } else {
                this.queryParams.beginTime = null;
                this.queryParams.endTime = null;
            }
            this.loading = true;
            this.axios.get(this.$apiUrl + "/developbackend/listLog", {
                params: this.queryParams,
                headers: this.headers
            }).then(res => {
                this.loading = false;
                if (res.data.code == 200) {
                    this.total = res.data.total;
                    this.list = res.data.rows;
                }
            });
        }
    }
}
</script>


<style scoped>
.log-container {
    height: 100%;
    padding-top: 5px;
    display: flex;
    flex-direction: column;
}

.data-container {
    overflow-y: scroll;
}
</style>


// WEBPACK FOOTER //
// log.vue?e3382878